import { SpinnerService } from '../services/spinner.service';
var SpinnerComponent = /** @class */ (function () {
    function SpinnerComponent(spinnerService) {
        this.spinnerService = spinnerService;
    }
    return SpinnerComponent;
}());
export { SpinnerComponent };
